import { useQuery } from '@tanstack/react-query';
import getWeatherOverrideApiRequestService from '../../service/getWeatherOverrideApiRequest/apiService';
import { useAuth } from '../../component/context/AuthContext/AuthContext';

const useWeatherOverrideApi = (airline: string) => {
  const { userData } = useAuth();

  // I will not put a staleTime here as I am refetching the API whenever the user changes the Airline Type
  // through Radio
  return useQuery({
    queryKey: [airline, userData?.access_token],
    queryFn: () =>
      getWeatherOverrideApiRequestService(airline, userData?.access_token),
    refetchOnWindowFocus: false,
    retry: 3, // Will retry 3 times before throwing error during failure
  });
};

export default useWeatherOverrideApi;
